export default {}

export function scrollToView(domElement, offsetTop) {
  if (domElement === null || domElement === undefined) return

  let topValue = domElement.offsetTop - (offsetTop ?? 0)

  // Tager højde for header show/hide
  if (topValue < document.documentElement.scrollTop) {
    topValue -= 56
  }
  if (topValue < 0) {
    topValue = 0
  }

  window.scrollTo({
    top: topValue,
    behavior: 'smooth',
  })
}
